import React, { useState, useEffect } from 'react';
import { Github, Linkedin, MessageCircle, Folder, Menu, X} from 'lucide-react';
import { FaReact, FaGitAlt, FaDatabase, FaAws, FaNodeJs, FaHtml5, FaCss3Alt, FaCloudflare, FaDocker, FaPython, FaPhp, FaJsSquare, FaUser, FaFingerprint, FaFigma, FaHome, FaFolderOpen, FaEnvelope, FaGoogle, FaLock, FaShieldAlt, FaMobile, FaMicrosoft, FaBootstrap, FaInstagram, FaFacebook, FaWhatsapp, FaTiktok, FaSpotify, FaSteam, FaTelegram, FaPinterest } from "react-icons/fa";
import { FaJava, FaThreads, FaXTwitter } from "react-icons/fa6";
import { FaYoutube, FaDiscord, FaGithub} from 'react-icons/fa';

import { TbBrandCSharp } from "react-icons/tb";
import { SiCloudflare, SiLinux, SiUbuntu, SiAndroidstudio, SiMongodb, SiApache, SiNginx, SiDocker, SiMysql, SiNextdotjs, SiElectron, SiKotlin, SiDart, SiAngular, SiRust} from "react-icons/si";
import { BiLogoVisualStudio } from "react-icons/bi";
import { RiTailwindCssFill } from "react-icons/ri";
import { RiPhpFill } from "react-icons/ri";
import { IoLogoFirebase } from "react-icons/io5";
import { GrOracle } from "react-icons/gr";
import { VscAzure } from "react-icons/vsc";
import { DiVisualstudio } from "react-icons/di";

import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { Typewriter } from 'react-simple-typewriter';
import TypingBackground from './TypingBackground';
import Preloader from './Preloader';
import ContactForm from './Contact';
import dp from '../assets/dp3.png';

import Asia from '../assets/asia.png';
import Advertising from '../assets/advertising.png';
import OCR from '../assets/ocr.png';
import Amethyst from '../assets/amethyst.png';
import CalX from '../assets/calx.png';


import cyberdevx from '../assets/cyberdevx.png';
import { LiaLinkedinIn } from 'react-icons/lia';
import TypingBackground1 from './TypingBackground1';
import { TfiAndroid } from 'react-icons/tfi';
import Technologies from './Technologies';
const ellipseConfigs = [
  {
    // First Ring
    radius: 45,
    icons: [
      <FaReact className="text-blue-700" size={36} />,
      <FaJsSquare className="text-yellow-400" size={36} />,
      <FaCss3Alt className="text-blue-400" size={36} />,
    ],
    names: [
      "React",
      "JavaScript",
      "CSS",
    ],
    animation: "spin-ellipse1",
    duration: 25,
    delay: 0,
    borderClass: "border-blue-400/60",
    borderWidth: "border-2",
  },
];

const ellipseConfigs2 = [
  {
    // Second Ring
    radius: 49,
    icons: [
      <FaHtml5 className="text-orange-400" size={36} />,
      <FaPython className="text-yellow-200" size={36} />,
      <FaPhp className="text-purple-400 " size={36} />,
    ],
    names: [
      "Html",
      "Python",
      "Php",
    ],
    animation: "spin-ellipse-op",
    duration: 30,
    delay: 0,
    borderClass: "border-blue-400/60",
    borderWidth: "border-2",
  },
];

const ellipseConfigs3 = [
    {
    // Third Ring
    radiusX: 100,
    radiusY: 72,
    icons: [
      <FaNodeJs className="text-green-500" size={36} />,
      <FaAws className="text-red-400" size={36} />,
      <FaGitAlt className="text-orange-400" size={36} />,

    ],
    names: [
      "Node.js",
      "AWS",
      "Git",
    ],
    animation: "spin-ellipse2",
    duration: 70,
    delay: 0,
    borderClass: "border-blue-500/40",
    borderWidth: "border-2",
  },
];

const ellipseConfigs4 = [
    {
    // Foruth Ring
    radiusX: 99,
    radiusY: 56,
    icons: [
      <FaDatabase className="text-blue-700" size={36} />,
      <FaDocker className="text-blue-300" size={36} />,
      <FaCloudflare className="text-orange-400" size={36} />,
    ],
    names: [
      "MySql",
      "Docker",
      "CloudFlare",
    ],
    animation: "spin-ellipse4",
    duration: 50,
    delay: 0,
    borderClass: "border-blue-500/40",
    borderWidth: "border-2",
  },
];

const ellipseConfigs5 = [
    {
    // Five Ring
    radiusX: 90,
    radiusY: 56,
    icons: [
      <FaFigma className="text-red-700" size={36} />,
    ],
    names: [
      "Figma",
    ],
    animation: "spin-ellipse2",
    duration: 30,
    delay: 0,
    borderClass: "border-blue-500/40",
    borderWidth: "border-2",
  },
];


const IconTooltip = ({ label }) => (
  <div className="absolute left-1/2 -translate-x-1/2 -top-8 bg-black/80 text-white px-2 py-1 rounded text-xs pointer-events-none z-100 whitespace-nowrap shadow">
    {label}
  </div>
);


const TechIcon = ({ icon, className = "" }) => (
  <div className={`w-12 h-12 md:w-16 md:h-16 bg-blue-900/30 backdrop-blur-sm border border-blue-500/30 rounded-full flex items-center justify-center text-blue-400 ${className}`}>
    {icon}
  </div>
);


const FloatingIcons = () => {
const techIcons = [
  { icon: <FaGoogle size={30} />, style: { top: '5%', right: '90%' }, delay: '0s' },
  { icon: <FaLock size={30} />, style: { top: '10%', right: '80%' }, delay: '0.5s' },
  { icon: <FaShieldAlt size={30} />, style: { top: '20%', right: '55%' }, delay: '1s' },
  { icon: <FaMobile size={30} />, style: { top: '4%', right: '10%' }, delay: '1.5s' },
  { icon: <FaMicrosoft size={30} />, style: { top: '13%', right: '7%' }, delay: '2s' },
  { icon: <FaJava size={30} />, style: { top: '30%', right: '6%' }, delay: '2.5s' },
  { icon: <TbBrandCSharp size={30} />, style: { top: '2%', left: '70%' }, delay: '3s' },
  { icon: <SiMysql size={30} />, style: { top: '1%', left: '30%' }, delay: '3.5s' },
  { icon: <TfiAndroid size={30} />, style: { top: '10%', left: '48%' }, delay: '3.5s' },
  { icon: <BiLogoVisualStudio size={30} />, style: { top: '15%', left: '5%' }, delay: '0s' },
  { icon: <FaJava size={30} />, style: { top: '18%', left: '90%' }, delay: '0s' }
];
  return (
    <div className="fixed absolute inset-0 overflow-hidden pointer-events-none">
      {techIcons.map((item, index) => (
        <div
          key={index}
          className="absolute animate-pulse"
          style={{
            ...item.style,
            animationDelay: item.delay,
            animationDuration: '3s'
          }}
        >
          <TechIcon
            icon={item.icon}
            className="fixed opacity-60 hover:opacity-100 transition-opacity duration-300 border border-purple-500 shadow-[0_0_8px_2px_rgba(168,85,247,0.6)] hover:shadow-[0_0_8px_2px_rgba(168,85,247,0.6)]bg-transparent rounded-full p-1 backdrop-blur"
          />
        </div>
      ))}
    </div>
  );
};


const technologies = [
  {
    name: 'JavaScript',
    icon: <FaJsSquare size={40} className="text-yellow-400" />,
    detail: 'Core programming language for web development.',
    lib: 'ES6+, DOM, Fetch API',
    experience: 85
  },
  {
    name: 'React',
    icon: <FaReact size={40} className="text-blue-400" />,
    detail: 'Library for building user interfaces.',
    lib: 'JSX, Hooks, React Router, Context API',
    experience: 87
  },
  {
    name: 'Node.js',
    icon: <FaNodeJs size={40} className="text-green-400" />,
    detail: 'JavaScript runtime built on Chrome\'s V8 engine.',
    lib: 'Express.js, REST APIs, File System, JWT',
    experience: 80
  },
  {
    name: 'HTML5',
    icon: <FaHtml5 size={40} className="text-orange-500" />,
    detail: 'Standard markup language for web pages.',
    lib: 'Semantic Tags, Forms, Canvas',
    experience: 100
  },
  {
    name: 'CSS3',
    icon: <FaCss3Alt size={40} className="text-blue-300" />,
    detail: 'Styling language for HTML documents.',
    lib: 'Flexbox, Grid, Animations, Media Queries',
    experience: 100
  },
  {
    name: 'Python',
    icon: <FaPython size={40} className="text-yellow-300" />,
    detail: 'High-level programming language for general-purpose tasks.',
    lib: 'Flask, Django, Pandas, NumPy',
    experience: 76
  },
  {
    name: 'SQL',
    icon: <FaDatabase size={40} className="text-purple-300" />,
    detail: 'Language for managing relational databases.',
    lib: 'MySQL, PostgreSQL, SQLite',
    experience: 95
  },
  {
    name: 'TailwindCSS',
    icon: <RiTailwindCssFill size={40} className="text-blue-300" />,
    detail: 'Utility-first CSS framework.',
    lib: 'Tailwind CLI, Plugins, Custom Theme',
    experience: 78
  },
  {
    name: 'Bootstrap',
    icon: <FaBootstrap size={40} className="text-purple-500" />,
    detail: 'CSS framework for responsive UI.',
    lib: 'Grid System, Components, JS Plugins',
    experience: 64
  },
  {
    name: 'Php',
    icon: <RiPhpFill size={40} className="text-purple-300" />,
    detail: 'Scripting language for server-side web development.',
    lib: 'Laravel, MySQLi, PDO',
    experience: 83
  },
  {
    name: 'C#',
    icon: <TbBrandCSharp size={40} className="text-blue-300" />,
    detail: 'General-purpose low-level language.',
    lib: 'Standard IO, Pointers, Data Structures',
    experience: 57
  },
  {
    name: 'Java',
    icon: <FaJava size={40} className="text-orange-300" />,
    detail: 'High-level object-oriented programming language.',
    lib: 'Spring Boot, JDBC, JavaFX',
    experience: 50
  },
  {
    name: 'Next.js',
    icon: <SiNextdotjs size={40} className="text-black dark:text-white" />,
    detail: 'React-based framework for building full-stack web applications.',
    lib: 'App Router, API Routes, Middleware',
    experience: 70
  },
  {
    name: 'Electron',
    icon: <SiElectron size={40} className="text-blue-400" />,
    detail: 'Framework for building desktop applications using JavaScript, HTML, and CSS.',
    lib: 'Electron Forge, IPC, Node Integration',
    experience: 67
  },
  {
    name: 'Kotlin',
    icon: <SiKotlin size={40} className="text-purple-500" />,
    detail: 'Modern, concise programming language for Android and backend development.',
    lib: 'Ktor, Coroutines, Jetpack Compose',
    experience: 50
  },
  {
    name: 'Dart',
    icon: <SiDart size={40} className="text-blue-500" />,
    detail: 'Client-optimized language for fast apps on any platform, often used with Flutter.',
    lib: 'Flutter, Dio, Bloc',
    experience: 55
  },
  {
    name: 'Angular',
    icon: <SiAngular size={40} className="text-red-600" />,
    detail: 'TypeScript-based front-end web framework maintained by Google.',
    lib: 'RxJS, Angular CLI, NgRx',
    experience: 45
  },
  {
    name: 'Rust',
    icon: <SiRust size={40} className="text-orange-500" />,
    detail: 'Performance-focused systems programming language with memory safety.',
    lib: 'Tokio, Actix, Serde',
    experience: 20
  }


];

const tools = [
  { name: 'Git', icon: <FaGitAlt size={40} className="text-orange-400" /> },
  { name: 'VS Code', icon: <BiLogoVisualStudio size={40} className="text-blue-500" /> },
  { name: 'Visual Studio', icon: <DiVisualstudio size={40} className="text-purple-500" /> },
  { name: 'Figma', icon: <FaFigma size={40} className="text-green-500" /> },
  { name: 'Oracle', icon: <GrOracle size={40} className="text-red-400" /> },
  { name: 'FireBase', icon: <IoLogoFirebase size={40} className="text-orange-400" /> },
  { name: 'Azure', icon: <VscAzure size={40} className="text-blue-500" /> },
  { name: 'AWS', icon: <FaAws size={40} className="text-yellow-500" /> },
  { name: 'MongoDB', icon: <SiMongodb size={40} className="text-green-500" /> },
  { name: 'Apache', icon: <SiApache size={40} className="text-red-600" /> },
  { name: 'Nginx', icon: <SiNginx size={40} className="text-green-600" /> },
  { name: 'Docker', icon: <SiDocker size={40} className="text-blue-400" /> },
  { name: 'Cloudflare', icon: <SiCloudflare size={40} className="text-orange-400" /> },
  { name: 'Linux', icon: <SiLinux size={40} className="text-yellow-500" /> },
  { name: 'Ubuntu', icon: <SiUbuntu size={40} className="text-orange-600" /> },
  { name: 'AS', icon: <SiAndroidstudio size={40} className="text-green-500" /> },  
];

const tabs = ["Websites", "Desktop Apps", "Mobile Apps"];

const projects = [
   {
    title: "Amethyst Community Official Website",
    image: Amethyst,
    category: "Websites",
    type: ["E-commerce", "AI"],
    description:"This is a website created for the amethyst community minecraft game server. This is a complete website that contains payment gateway, server details, and everything else.",
    url: "https://www.amethystcommunity.net",
    web: "www.amethystcommunity.net",
    tech: ["HTML", "CSS", "ReactJS", "TailwindCSS", "Node.JS", "MySQL", "Firebase", "PayHere"],
  },  
  {
    title: "Oshe Asia Pacific Auto Group Official Website",
    image: Asia,
    category: "Websites",
    type: ["AutoMobile", "E-commerce"],
    description:"Premium automotive detailing services in Melbourne’s east, delivering showroom-quality results. From washes to ceramic coatings, Oshe Asia Pacific Auto Group provides professional vehicle care and protection services across Australia.",
    url: "https://www.osheasiapacific.com.au",
    web: "www.osheasiapacific.com.au",
    tech: ["HTML", "CSS", "ReactJS", "TailwindCSS", "Node.JS", "MySQL"],
  },
   {
    title: "S & R Advertising Official Website",
    image: Advertising,
    category: "Websites",
    type: "E-commerce",
    description:"Another website dedicated to S & R Advertising company.The S & R Advertising website basically provides a rough estimate through a quiz and contains all the usual things on the website.",
    url: "https://www.sandradvertising.lk",
    web: "www.sandradvertising.lk",
    tech: ["HTML", "CSS", "TailwindCSS", "ReactJS", "Node.js"],
  },  
  {
    title: "Sinhala Optical Character Recognition",
    image: OCR,
    category: "Websites",
    type: ["AI", "Eductaion"],
    description:"Here you can currently insert an image under JPG, PNG, GIF and copy its text.Currently supports Sinhala and English.More features are expected to be added, so stay tuned.",
    url: "https://ocr.devsithum.com",
    web: "ocr.devsithum.com",
    tech: ["HTML", "CSS", "ReactJS", "TailwindCSS", "Node.JS", "MySQL"],
  },


   {
    title: "Cal X for Android",
    image: CalX,
    category: "Mobile Apps",
    type: "E-commerce",
    description:"Date first available at Amazon.in: September 7, 2021",
    url: "https://www.amazon.in/SGP-Corporation-Cal-X/dp/B09DXF9RR7",
    web: "www.amazon.in",
    tech: ["Kotlin", "AWS"],
  },  
];


const Home = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const [hovered, setHovered] = useState({ ellipse: null, idx: null });
  const [activeTab, setActiveTab] = useState("Websites");
  const [currentPage, setCurrentPage] = useState(1);

  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoaded(true), 10500); 
    return () => clearTimeout(timer);
  }, []);


  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const filteredProjects = projects.filter((p) => p.category === activeTab);
  const projectsPerPage = 3;
  const totalPages = Math.ceil(filteredProjects.length / projectsPerPage);
  const currentProjects = filteredProjects.slice(
    (currentPage - 1) * projectsPerPage,
    currentPage * projectsPerPage
  );

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setCurrentPage(1);
  };

  
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden'; 
    } else {
      document.body.style.overflow = 'auto';  
    }
  }, [isMenuOpen]);



  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setActiveSection(sectionId);
      setIsMenuOpen(false);
    }
  };



  const navItems = [
  { name: 'Home', icon: <FaHome /> },
  { name: 'About', icon: <FaUser /> },
  { name: 'Projects', icon: <FaFolderOpen /> },
  { name: 'Contact', icon: <FaEnvelope /> },
  ];

  return isLoaded ?(
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-slate-950 to-gray-900 text-white relative overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgb(1, 0, 71),transparent)] animate-pulse"></div>
      
      {/* Floating Tech Icons */}
      <FloatingIcons />
      <TypingBackground />
      <TypingBackground1 />
      

      {/* Navigation */}
      <nav className="top-0 left-0 w-full z-50 bg-transparent p-6 md:p-8 flex justify-between items-center">
        <div className="text-2xl font-bold drop-shadow-[0_0_8px_rgba(255,255,255,0.7)]">
          <a href='/'><span className="text-2xl md:text-3xl font-bold relative inline-block group pb-3">
            <span className="text-blue-400">Dev</span> Sithum
            <span className="absolute left-0 bottom-0 h-1 w-full origin-right scale-x-0 group-hover:scale-x-100 transition-transform duration-500 ease-out bg-gradient-to-l from-blue-400 via-blue-500 to-blue-700 shadow-[0_4px_16px_0_rgba(59,130,246,0.7)] rounded-full" />
          </span>
          </a>
        </div>

        {/* Desktop Navigation */}
        <div className="hidden md:flex space-x-8 font-bold drop-shadow-[0_0_8px_rgba(255,255,255,0.7)]">
          {navItems.map(({ name, icon }) => (
            <button
              key={name}
              onClick={() => scrollToSection(name)}
              className={`relative flex items-center space-x-2 group text-gray-300 hover:text-white transition-colors duration-300 ${
                activeSection === name ? 'text-blue-400' : ''
              }`}
            >
              {icon}
              <span>{name}</span>
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-blue-400 rounded-full transition-all duration-300 group-hover:w-full group-hover:shadow-[0_0_8px_2px_rgba(59,130,246,0.7)]" />
            </button>
          ))}
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={toggleMenu}
          className="md:hidden z-60 relative"
        >
          {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="absolute top-0 left-0 w-full h-screen bg-gray-900/80 backdrop-blur-sm flex flex-col justify-center items-center space-y-8 md:hidden font-bold z-50">
            {navItems.map(({ name, icon }) => (
              <button
                key={name}
                onClick={() => {
                  scrollToSection(name);
                }}
                className="flex items-center space-x-3 text-2xl text-gray-300 hover:text-blue-400 transition-colors duration-300"
              >
                {icon}
                <span>{name}</span>
              </button>
            ))}
          </div>
        )}

        {/* Social Links */}
        <div className="hidden md:flex space-x-4 drop-shadow-[0_0_8px_rgba(255,255,255,0.7)] ">
          <a href="https://www.linkedin.com/in/sithum-gimhana-a47a27294" target='_blank' rel="noreferrer" className="text-gray-400 hover:text-blue-400 hover:drop-shadow-[0_0_8px_rgba(255,255,255,0.7)] transition-colors duration-300 ">
            <Linkedin className="w-7 h-7" />
          </a>
          <a href="https://github.com/SithumGimhana" target='_blank' rel="noreferrer" className="text-gray-400 hover:text-blue-400 hover:drop-shadow-[0_0_8px_rgba(255,255,255,0.7)] transition-colors duration-300">
            <Github className="w-7 h-7" />
          </a>
          <a href="https://wa.me/758533225" target='_blank' rel="noreferrer" className="text-gray-400 hover:text-blue-400 hover:drop-shadow-[0_0_8px_rgba(255,255,255,0.7)] transition-colors duration-300">
            <MessageCircle className="w-7 h-7" />
          </a>
          <a href="https://www.instagram.com/sithum_gimhana22/" target='_blank' rel="noreferrer" className="text-gray-400 hover:text-blue-400 hover:drop-shadow-[0_0_8px_rgba(255,255,255,0.7)] transition-colors duration-300">
            <FaInstagram className="w-7 h-7" />
          </a>
          <a href="https://www.facebook.com/sithum.gimhana.645415?mibextid=ZbWKwL" target='_blank' rel="noreferrer" className="text-gray-400 hover:text-blue-400 hover:drop-shadow-[0_0_8px_rgba(255,255,255,0.7)] transition-colors duration-300">
            <FaFacebook className="w-7 h-7" />
          </a>            
        </div>
      </nav>

      {/* Hero Section */}
      <section id="Home" className="relative z-10 min-h-screen flex items-center">
        <div className="container mx-auto px-6 md:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Content */}

            
            <div className="md:hidden flex justify-center items-center inset-0">
              <div className="w-60 h-60 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 p-1 flex items-center justify-center">
                <div className="w-full h-full rounded-full bg-gray-800 flex items-center justify-center overflow-hidden">
                  <img
                    className="w-[full] h-[full] object-cover rounded-full"
                    src={dp}
                    alt="Profile"
                  />
                </div>
              </div>
            </div>

            <div className="space-y-6">
              <p className="text-blue-400 text-lg font-medium [text-shadow:0_0_8px_rgba(59,130,246,0.8),0_0_16px_rgba(59,130,246,0.6)]">Hello World, I'm Dev Sithum Gimhana</p>
              
              <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold leading-tight">
                Full Stack Developer <br />
                <span className="text-blue-400 [text-shadow:0_0_8px_rgba(59,130,246,0.8),0_0_16px_rgba(59,130,246,0.6)]">
                  <Typewriter
                    words={['Software Developer', 'Mobile App Developer', 'Web Developer', 'Game Developer', 'Bot Developer', 'UI/UX Designer']}
                    loop={0} 
                    cursor
                    cursorStyle="|"
                    typeSpeed={80}
                    deleteSpeed={50}
                    delaySpeed={1200}
                  />
                </span>                
              </h1>

              <p className="text-gray-300 text-lg md:text-xl leading-relaxed max-w-2xl">
                  Passionate about creating innovative and functional, agile digital solutions and cybersecurity practices.Happy Hacking!
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 pt-6">
                <button 
                  onClick={() => scrollToSection('Projects')}
                  className="bg-blue-500 hover:bg-blue-600 text-white px-8 py-3 rounded-full font-medium transition-colors duration-300 flex items-center justify-center gap-2">
                  
                  <Folder className="w-4 h-4" />
                  Projects
                </button>
                <button 
                  onClick={() => scrollToSection('Contact')}
                  className="border border-gray-600 hover:border-blue-500 text-gray-300 hover:text-white px-8 py-3 rounded-full font-medium transition-colors duration-300"
                >
                  Contact
                </button>
              </div>
              
              {/* Social Links Mobile */}
              <div className="flex space-x-6 md:hidden pt-4">
                <a href="https://www.linkedin.com/in/sithum-gimhana-a47a27294/" target='_blank' rel="noreferrer" className="text-gray-400 hover:text-blue-400 transition-colors">
                  <Linkedin className="w-6 h-6" />
                </a>
                <a href="https://github.com/SithumGimhana" target='_blank' rel="noreferrer" className="text-gray-400 hover:text-blue-400 transition-colors">
                  <Github className="w-6 h-6" />
                </a>
                <a href="https://wa.me/758533225" target='_blank' rel="noreferrer" className="text-gray-400 hover:text-blue-400 transition-colors">
                  <MessageCircle className="w-6 h-6" />
                </a>
                <a href="https://www.instagram.com/sithum_gimhana22/" target='_blank' rel="noreferrer" className="text-gray-400 hover:text-blue-400 transition-colors">
                  <FaInstagram className="w-6 h-6" />
                </a>                
                <a href="https://www.facebook.com/sithum.gimhana.645415?mibextid=ZbWKwL" target='_blank' rel="noreferrer" className="text-gray-400 hover:text-blue-400 transition-colors">
                  <FaFacebook className="w-6 h-6" />
                </a>                
              </div>

            </div>
          
        
          <div className="relative w-full">
            {/* Desktop/Tablet: align right, large image */}
            <div className="hidden md:flex justify-end w-full "style={{ marginLeft: '-7rem' }}>
              

                <div className="relative w-72 h-72 md:w-96 md:h-96 flex items-center justify-center">
                  
                  {/* Profile Image First */}
                  <div
                    className="
                      absolute w-[90%] h-[90%] rounded-full overflow-hidden flex items-center justify-center
                      border-4 border-blue-500
                      shadow-[0_0_15px_5px_rgba(59,130,246,0.7)]
                      transition-transform duration-300 ease-in-out
                      hover:scale-105
                    "
                  >

                  <LazyLoadImage
                      alt="logo"
                      className="w-full h-full object-cover rounded-full"
                      effect="blur"
                      wrapperProps={{
                          style: {transitionDelay: "1s"},
                      }}
                      src={dp} 
                  />
                  </div>


                  {ellipseConfigs.map((ellipse, ellipseIdx) => (
                  <div
                    key={ellipseIdx}
                    className="absolute inset-0 flex items-center justify-center pointer-events-none"
                    style={{
                      animation: `${ellipse.animation} ${ellipse.duration}s linear infinite`,
                      animationDelay: `${ellipse.delay}s`,
                    }}
                  >
                    
                  <div
                    className={`absolute w-[22rem] h-[22rem] rounded-full ${ellipse.borderWidth} ${ellipse.borderClass} ${
                      ellipseIdx === 1 ? "shadow-[0_0_40px_10px_rgba(255,0,0,0.4)]" : ""
                    }`}
                    style={{
                      transform: ellipse.radiusY
                        ? `scaleY(${ellipse.radiusY / (ellipse.radiusX || ellipse.radius)})`
                        : 'none',
                      borderStyle: 'solid',
                      zIndex: 0,
                    }}
                  />

                    <div className="relative w-full h-full ">
                    {ellipse.icons.map((icon, idx) => {
                      const count = ellipse.icons.length;
                      const angle = (idx / count) * 2 * Math.PI;
                      const rx = ellipse.radiusX || ellipse.radius;
                      const ry = ellipse.radiusY || ellipse.radius;
                      const x = 50 + Math.cos(angle) * rx;
                      const y = 50 + Math.sin(angle) * ry;
                      return (
                        <div
                          key={idx}
                          className="absolute z-60"
                          style={{
                            left: `${x}%`,
                            top: `${y}%`,
                            transform: 'translate(-50%, -50%)',
                            pointerEvents: 'auto',
                          }}
                          onMouseEnter={() => setHovered({ ellipse: 0, idx })}
                          onMouseLeave={() => setHovered({ ellipse: null, idx: null })}
                        >
                        <div className="relative flex z-50 flex-col items-center">
                          {hovered.ellipse === 0 && hovered.idx === idx && (
                            <div className="absolute z-50 left-1/2 -translate-x-1/2 top-[calc(100%+2rem)] bg-black/80 text-white px-2 py-1 rounded text-xs pointer-events-none whitespace-nowrap shadow">
                              {ellipse.names[idx]}
                            </div>
                          )}
                        <div className="text-white bg-slate-950 border border-blue-500 rounded-full p-3 
                          shadow-[12px_0_16px_rgba(59,130,246,0.6),-12px_0_16px_rgba(59,130,246,0.6)] 
                          transition duration-300 hover:shadow-[16px_0_20px_rgba(59,130,246,0.8),-16px_0_20px_rgba(59,130,246,0.8)] 
                          hover:scale-125 hover:bg-blue-500 cursor-pointer">
                            {icon}
                          </div>
                        </div>

                        </div>
                      );
                    })}
                    </div>
                  </div>
                ))}



                  {/*Second Ring*/}        
                  {ellipseConfigs2.map((ellipse2, ellipse2Idx) => (
                  <div
                    key={ellipse2Idx}
                    className="absolute inset-0 flex items-center justify-center pointer-events-none"
                    style={{
                      animation: `${ellipse2.animation} ${ellipse2.duration}s linear infinite`,
                      animationDelay: `${ellipse2.delay}s`,
                    }}
                  >
                    <div className="relative w-full h-full ">
                    {ellipse2.icons.map((icon, idx) => {
                      const count = ellipse2.icons.length;
                      const angle = (idx / count) * 2 * Math.PI;
                      const rx = ellipse2.radiusX || ellipse2.radius;
                      const ry = ellipse2.radiusY || ellipse2.radius;
                      const x = 50 + Math.cos(angle) * rx;
                      const y = 50 + Math.sin(angle) * ry;
                      return (
                        <div
                          key={idx}
                          className="absolute z-60"
                          style={{
                            left: `${x}%`,
                            top: `${y}%`,
                            transform: 'translate(-50%, -50%)',
                            pointerEvents: 'auto',
                          }}
                          onMouseEnter={() => setHovered({ ellipse2: 0, idx })}
                          onMouseLeave={() => setHovered({ ellipse2: null, idx: null })}
                        >
                        <div className="relative flex z-50 flex-col items-center">
                          {hovered.ellipse2 === 0 && hovered.idx === idx && (
                            <div className="absolute z-50 left-1/2 -translate-x-1/2 top-[calc(100%+2rem)] bg-black/80 text-white px-2 py-1 rounded text-xs pointer-events-none whitespace-nowrap shadow">
                              {ellipse2.names[idx]}
                            </div>
                          )}
                        <div className="text-white bg-slate-950 border border-blue-500 rounded-full p-3 
                          shadow-[12px_0_16px_rgba(59,130,246,0.6),-12px_0_16px_rgba(59,130,246,0.6)] 
                          transition duration-300 hover:shadow-[16px_0_20px_rgba(59,130,246,0.8),-16px_0_20px_rgba(59,130,246,0.8)] 
                          hover:scale-125 hover:bg-blue-500 cursor-pointer">
                            {icon}
                          </div>
                        </div>

                        </div>
                      );
                    })}
                    </div>
                  </div>
                ))}



              {/*Third Ring*/}
              {ellipseConfigs3.map((ellipse3, ellipse3Idx) => (
                  <div
                    key={ellipse3Idx}
                    className="absolute inset-0 flex items-center justify-center pointer-events-none"
                    style={{
                      animation: `${ellipse3.animation} ${ellipse3.duration}s linear infinite`,
                      animationDelay: `${ellipse3.delay}s`,
                    }}
                  >
                    
                  <div
                    className={`absolute w-[50rem] h-[50rem] rounded-full ${ellipse3.borderWidth} ${ellipse3.borderClass} ${
                      ellipse3Idx === 1 ? "shadow-[0_0_40px_10px_rgba(255,0,0,0.4)]" : ""
                    }`}
                    style={{
                      transform: ellipse3.radiusY
                        ? `scaleY(${ellipse3.radiusY / (ellipse3.radiusX || ellipse3.radius)})`
                        : 'none',
                      borderStyle: 'solid',
                      zIndex: 0,
                    }}
                  />

                    <div className="relative w-full h-full">
                  {ellipse3.icons.map((icon, idx) => {
                      const count = ellipse3.icons.length;
                      const angle = (idx / count) * 2 * Math.PI;
                      const rx = ellipse3.radiusX || ellipse3.radius;
                      const ry = ellipse3.radiusY || ellipse3.radius;
                      const x = 50 + Math.cos(angle) * rx;
                      const y = 50 + Math.sin(angle) * ry;
                      return (
                        <div
                          key={idx}
                          className="absolute"
                          style={{
                            left: `${x}%`,
                            top: `${y}%`,
                            transform: 'translate(-50%, -50%)',
                            pointerEvents: 'auto',
                          }}
                          onMouseEnter={() => setHovered({ ellipse3: 0, idx })}
                          onMouseLeave={() => setHovered({ ellipse3: null, idx: null })}
                        >
                          <div className="relative flex flex-col items-center">
                            {hovered.ellipse3 === 0 && hovered.idx === idx && (
                              <IconTooltip label={ellipse3.names[idx]} />
                            )}
                          <div className="text-white bg-slate-950 border border-blue-500 rounded-full p-3 
                            shadow-[12px_0_16px_rgba(59,130,246,0.6),-12px_0_16px_rgba(59,130,246,0.6)] 
                            transition duration-300 hover:shadow-[16px_0_20px_rgba(59,130,246,0.8),-16px_0_20px_rgba(59,130,246,0.8)] 
                            hover:scale-125 hover:bg-blue-500 cursor-pointer">                      
                            {icon}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                    </div>
                  </div>
                ))}



              {/*Fourth Ring*/}
              {ellipseConfigs4.map((ellipse4, ellipse4Idx) => (
                  <div
                    key={ellipse4Idx}
                    className="absolute inset-0 flex items-center justify-center pointer-events-none"
                    style={{
                      animation: `${ellipse4.animation} ${ellipse4.duration}s linear infinite`,
                      animationDelay: `${ellipse4.delay}s`,
                    }}
                  >
                    
                  <div
                    className={`absolute w-[47rem] h-[47rem] rounded-full ${ellipse4.borderWidth} ${ellipse4.borderClass} ${
                      ellipse4Idx === 1 ? "shadow-[0_0_40px_10px_rgba(255,0,0,0.4)]" : ""
                    }`}
                    style={{
                      transform: ellipse4.radiusY
                        ? `scaleY(${ellipse4.radiusY / (ellipse4.radiusX || ellipse4.radius)})`
                        : 'none',
                      borderStyle: 'solid',
                      zIndex: 0,
                    }}
                  />

                    <div className="relative w-full h-full">
                  {ellipse4.icons.map((icon, idx) => {
                      const count = ellipse4.icons.length;
                      const angle = (idx / count) * 2 * Math.PI;
                      const rx = ellipse4.radiusX || ellipse4.radius;
                      const ry = ellipse4.radiusY || ellipse4.radius;
                      const x = 50 + Math.cos(angle) * rx;
                      const y = 50 + Math.sin(angle) * ry;
                      return (
                        <div
                          key={idx}
                          className="absolute"
                          style={{
                            left: `${x}%`,
                            top: `${y}%`,
                            transform: 'translate(-50%, -50%)',
                            pointerEvents: 'auto',
                          }}
                          onMouseEnter={() => setHovered({ ellipse4: 0, idx })}
                          onMouseLeave={() => setHovered({ ellipse4: null, idx: null })}
                        >
                          <div className="relative flex flex-col items-center">
                            {hovered.ellipse4 === 0 && hovered.idx === idx && (
                              <IconTooltip label={ellipse4.names[idx]} />
                            )}
                          <div className="text-white bg-slate-950 border border-blue-500 rounded-full p-3 
                            shadow-[12px_0_16px_rgba(59,130,246,0.6),-12px_0_16px_rgba(59,130,246,0.6)] 
                            transition duration-300 hover:shadow-[16px_0_20px_rgba(59,130,246,0.8),-16px_0_20px_rgba(59,130,246,0.8)] 
                            hover:scale-125 hover:bg-blue-500 cursor-pointer">
                            {icon}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                    </div>
                  </div>
                ))}


              {/*Fourth Ring*/}
              {ellipseConfigs5.map((ellipse5, ellipse5Idx) => (
                  <div
                    key={ellipse5Idx}
                    className="absolute inset-0 flex items-center justify-center pointer-events-none"
                    style={{
                      animation: `${ellipse5.animation} ${ellipse5.duration}s linear infinite`,
                      animationDelay: `${ellipse5.delay}s`,
                    }}
                  >
                    
                  <div
                    className={`absolute w-[40rem] h-[40rem] rounded-full ${ellipse5.borderWidth} ${ellipse5.borderClass} ${
                      ellipse5Idx === 1 ? "shadow-[0_0_40px_10px_rgba(255,0,0,0.4)]" : ""
                    }`}
                    style={{
                      transform: ellipse5.radiusY
                        ? `scaleY(${ellipse5.radiusY / (ellipse5.radiusX || ellipse5.radius)})`
                        : 'none',
                      borderStyle: 'solid',
                      zIndex: 0,
                    }}
                  />

                    <div className="relative w-full h-full">
                  {ellipse5.icons.map((icon, idx) => {
                      const count = ellipse5.icons.length;
                      const angle = (idx / count) * 2 * Math.PI;
                      const rx = ellipse5.radiusX || ellipse5.radius;
                      const ry = ellipse5.radiusY || ellipse5.radius;
                      const x = 50 + Math.cos(angle) * rx;
                      const y = 50 + Math.sin(angle) * ry;
                      return (
                        <div
                          key={idx}
                          className="absolute"
                          style={{
                            left: `${x}%`,
                            top: `${y}%`,
                            transform: 'translate(-50%, -50%)',
                            pointerEvents: 'auto',
                          }}
                          onMouseEnter={() => setHovered({ ellipse5: 0, idx })}
                          onMouseLeave={() => setHovered({ ellipse5: null, idx: null })}
                        >
                          <div className="relative flex flex-col items-center">
                            {hovered.ellipse5 === 0 && hovered.idx === idx && (
                              <IconTooltip label={ellipse5.names[idx]} />
                            )}
                          <div className="text-white bg-slate-950 border border-blue-500 rounded-full p-3 
                            shadow-[12px_0_16px_rgba(59,130,246,0.6),-12px_0_16px_rgba(59,130,246,0.6)] 
                            transition duration-300 hover:shadow-[16px_0_20px_rgba(59,130,246,0.8),-16px_0_20px_rgba(59,130,246,0.8)] 
                            hover:scale-125 hover:bg-blue-500 cursor-pointer">
                            {icon}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                    </div>
                  </div>
                ))}


                {/* Animations */}
                <style>{`
                  @keyframes spin-ellipse1 {
                    0% { transform: rotate(0deg);}
                    100% { transform: rotate(360deg);}
                  }
                  @keyframes spin-ellipse2 {
                    0% { transform: rotate(0deg);}
                    100% { transform: rotate(-360deg);}
                  }
                  @keyframes spin-ellipse-op {
                    0% { transform: rotate(0deg);}
                    100% { transform: rotate(-360deg);}
                  }
                  @keyframes spin-ellipse4 {
                    0% { transform: rotate(0deg);}
                    100% { transform: rotate(360deg);}
                  }

                `}</style>
              </div>
            </div>
          </div> 
          </div>
        </div>
      </section>



    {/* About Section */}
    <section id="About" className="relative z-10 py-20 bg-black/20 backdrop-blur-sm text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h2 className="text-3xl md:text-4xl font-bold relative inline-block group [text-shadow:0_0_8px_rgba(59,130,246,0.8),0_0_16px_rgba(59,130,246,0.6)] pb-3">
            About <span className="text-blue-400">Me</span>
            <span className="absolute left-0 bottom-0 h-1 w-full origin-right scale-x-0 group-hover:scale-x-100 transition-transform duration-500 ease-out bg-gradient-to-l from-blue-400 via-blue-500 to-blue-700 shadow-[0_4px_16px_0_rgba(59,130,246,0.7)] rounded-full" />
          </h2>
        </div>

        <div className="grid gap-8 md:grid-cols-2">
          {/* Card 1 */}
          <div className="bg-gray-900 rounded-lg p-6 hover:bg-slate-950 border-t-4 border-blue-600 shadow-lg shadow-blue-500/30 transition-all duration-300 hover:shadow-2xl hover:shadow-blue-600/80 hover:scale-105 hover:border-blue-500 hover:-translate-y-1 h-full group">
            <div className="flex items-center mb-4">
              <FaUser className="text-2xl text-blue-600 mr-3 group-hover:text-blue-500 transition" />
              <h3 className="text-xl font-semibold text-blue-500">Who am I?</h3>
            </div>
            <p className="text-gray-300 text-left">
              I am Dev Sithum Gimhana. I am passionate about creating innovative and functional, agile digital solutions and cybersecurity practices. I seek new solutions to existing problems.
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-gray-900 rounded-lg p-6 hover:bg-slate-950 border-t-4 border-blue-600 shadow-lg shadow-blue-500/30 transition-all duration-500 hover:shadow-2xl hover:shadow-blue-600/80 hover:scale-105 hover:border-blue-500 hover:-translate-y-1 h-full group">
            <div className="flex items-center mb-4">
              <FaFingerprint className="text-2xl text-blue-600 mr-3 group-hover:text-blue-500 transition" />
              <h3 className="text-xl font-semibold text-blue-500">My Profile</h3>
            </div>
            <p className="text-gray-300 text-left">
              I do software development, mobile app development, game development, web development, AI bot development, UI/UX design, database handling, server handling, etc.<br /><br />
              I adapt quickly to new environments and technologies, including artificial intelligence, have a keen attention to detail, and am committed to delivering high-quality outputs.
            </p>
          </div>
        </div>

        {/* Technologies */}
        <Technologies technologies={technologies} />

        {/* Tools */}
        <div className="mt-16">
        <div className="text-center mb-8">
          <h2 className="text-3xl md:text-4xl font-bold relative inline-block group [text-shadow:0_0_8px_rgba(59,130,246,0.8),0_0_16px_rgba(59,130,246,0.6)] pb-3">
            Tools
            <span className="absolute left-0 bottom-0 h-1 w-full origin-right scale-x-0 group-hover:scale-x-100 transition-transform duration-500 ease-out bg-gradient-to-l from-blue-400 via-blue-500 to-blue-700 shadow-[0_4px_16px_0_rgba(59,130,246,0.7)] rounded-full" />
          </h2>
        </div>

          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-8 lg:grid-cols-8 gap-4 justify-items-center">

            {tools.map((tool, index) => (
              <div
                key={index}
                className="w-36 sm:w-30 md:w-30 bg-slate-950 hover:bg-slate-900 border-2 border-blue-500 shadow-[0_0_20px_4px_rgba(59,130,246,0.6)] hover:scale-110 transition-transform duration-300 rounded-2xl p-4 flex flex-col items-center cursor-pointer"
              >
                {tool.icon}
                <h4 className="text-white text-sm sm:text-base mt-2">{tool.name}</h4>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>



    {/* Project Section*/}
    <section id="Projects" className="relative z-10 py-20 px-4 md:px-12">
        <div className="text-center mb-8">
          <h2 className="text-3xl md:text-4xl font-bold relative inline-block group [text-shadow:0_0_8px_rgba(59,130,246,0.8),0_0_16px_rgba(59,130,246,0.6)] pb-3">
            Projects
            <span className="absolute left-0 bottom-0 h-1 w-full origin-right scale-x-0 group-hover:scale-x-100 transition-transform duration-500 ease-out bg-gradient-to-l from-blue-400 via-blue-500 to-blue-700 shadow-[0_4px_16px_0_rgba(59,130,246,0.7)] rounded-full" />
          </h2>
        </div>

      {/* Tabs */}
      <div className="flex flex-wrap justify-center gap-3 mb-10">
        {tabs.map((tab) => (
          <button
            key={tab}
            onClick={() => handleTabChange(tab)}
            className={`px-4 py-2 rounded-full transition-all duration-300 ${
              activeTab === tab
                ? "bg-blue-600 text-white shadow-lg shadow-blue-500/30"
                : "bg-slate-800 text-gray-300 hover:bg-slate-700"
            }`}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Projects Grid */}
      <div className="grid md:grid-cols-3 gap-6 items-center justify-center ">
        {currentProjects.length === 0 ? (
          <div className="col-span-full text-center text-gray-400 text-lg">
            Server is not updated.
          </div>
        ) : (
          currentProjects.map((project, index) => (
            <div
              key={index}
              className="bg-slate-900 rounded-xl  p-5 shadow-lg shadow-blue-500/100 hover:shadow-blue-500/100 transition-all hover:scale-[1.02] hover:bg-slate-950"
            >
              <LazyLoadImage
                src={project.image}
                alt={project.title}
                className="w-full h-full object-cover rounded-lg mb-4"
                effect="blur"
                wrapperProps={{
                    style: {transitionDelay: "1s"},
                }}  
              />
              <h3 className="text-xl font-bold text-blue-400 mb-2">{project.title}</h3>
              <p className="text-gray-300 text-sm mb-3">{project.description}</p>
              <p className="text-blue-400 text-left text-sm mb-3">{project.web}</p>
              <div className="flex flex-wrap gap-2 mb-4">
                {project.tech.map((t, i) => (
                  <span key={i} className="text-xs bg-blue-800 px-2 py-1 rounded text-blue-200">
                    {t}
                  </span>
                ))}
              </div>
              {project.url && (
                <a
                  href={project.url}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-block mt-auto text-sm text-blue-400 hover:text-blue-100 hover:bg-blue-700 rounded-xl p-2 duration-300 transform"
                >
                  Visit Site ↗
                </a>
              )}
            </div>
          ))
        )}
      </div>

      {/* Pagination */}
      {currentProjects.length > 0 && totalPages > 1 && (
        <div className="flex justify-center mt-8 gap-2">
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((n) => (
            <button
              key={n}
              onClick={() => setCurrentPage(n)}
              className={`w-8 h-8 rounded-full text-sm font-bold ${
                n === currentPage
                  ? "bg-blue-600 text-white"
                  : "bg-slate-700 text-gray-300 hover:bg-slate-600"
              }`}
            >
              {n}
            </button>
          ))}
        </div>
      )}
    </section>



    {/* Contact Section */}
    <section id="Contact" className="relative z-10 py-20 bg-black/20 backdrop-blur-sm">
      <div className="text-center mb-2">
        <h2 className="text-3xl md:text-4xl font-bold relative inline-block group [text-shadow:0_0_8px_rgba(59,130,246,0.8),0_0_16px_rgba(59,130,246,0.6)] pb-3">
          Contact <span className="text-blue-400">Me</span>
          <span className="absolute left-0 bottom-0 h-1 w-full origin-right scale-x-0 group-hover:scale-x-100 transition-transform duration-500 ease-out bg-gradient-to-l from-blue-400 via-blue-500 to-blue-700 shadow-[0_4px_16px_0_rgba(59,130,246,0.7)] rounded-full" />
        </h2>
      </div>

      <div>
        <ContactForm />
      </div>
    </section>


    {/* Footer Section */}
    <footer className="relative bg-transparent text-gray-300 px-6 py-10">
      <div className="max-w-7xl mx-auto grid gap-10 md:grid-cols-4">
        {/* Brand */}
        <div className="text-center md:text-left">
          <span className="text-2xl md:text-3xl font-bold relative inline-block group [text-shadow:0_0_8px_rgba(59,130,246,0.8),0_0_16px_rgba(59,130,246,0.6)] pb-2">
            <span className="text-blue-400">Dev</span> Sithum
            <span className="absolute left-0 bottom-0 h-1 w-full origin-right scale-x-0 group-hover:scale-x-100 transition-transform duration-500 ease-out bg-gradient-to-l from-blue-400 via-blue-500 to-blue-700 shadow-[0_4px_16px_0_rgba(59,130,246,0.7)] rounded-full" />
          </span>
          <p className="mt-2 [text-shadow:0_0_8px_rgba(59,130,246,0.8),0_0_16px_rgba(59,130,246,0.6)]">
            Full Stack Developer - Crafting modern desktop, web & mobile experiences
          </p>
          <div className="mt-4">
            <p className="font-semibold">Powered By</p>
            <img
              src={cyberdevx}
              alt="CyberDevX"
              className="h-10 mt-2 mx-auto md:mx-0"
            />
          </div>
        </div>


        {/* Links */}
        <div>
          <h3 className="text-blue-400 font-semibold mb-2 text-xl">Links</h3>
          <ul className="space-y-1 [text-shadow:0_0_8px_rgba(59,130,246,0.8),0_0_16px_rgba(59,130,246,0.6)]">
            <li><a href="/" className="hover:text-blue-600 duration-300">Home</a></li>
            <li><a href="#About" className="hover:text-blue-600 duration-300">About</a></li>
            <li><a href="#Projects" className="hover:text-blue-600 duration-300">Projects</a></li>
            <li><a href="#Contact" className="hover:text-blue-600 duration-300">Contact</a></li>
          </ul>
        </div>

        {/* Legal */}
        <div>
          <h3 className="text-blue-400 font-semibold mb-2 text-xl">Legal</h3>
          <ul className="space-y-1 [text-shadow:0_0_8px_rgba(59,130,246,0.8),0_0_16px_rgba(59,130,246,0.6)]">
            <li><a href="/" className="hover:text-blue-600 duration-300">Terms & Conditions</a></li>
            <li><a href="/" className="hover:text-blue-600 duration-300">Privacy Policy</a></li>
            <li><a href="/" className="hover:text-blue-600 duration-300">Support Policy</a></li>
            <li><a href="/" className="hover:text-blue-600 duration-300">Cookies</a></li>
          </ul>
        </div>

        {/* Social Media */}
        <div>
          <h3 className="text-blue-400 font-semibold mb-2 text-xl">Follow Me</h3>
          <div className="sm:items-center justify-center flex flex-wrap gap-4 text-2xl">
            {[
              { icon: <LiaLinkedinIn />, label: 'LinkedIn', href: 'https://www.linkedin.com/in/sithum-gimhana-a47a27294' },
              { icon: <FaGithub />, label: 'GitHub', href: 'https://github.com/SithumGimhanahttps://github.com/SithumGimhana' },
              { icon: <FaWhatsapp />, label: 'WhatsApp', href: 'https://wa.me/758533225' },
              { icon: <FaFacebook />, label: 'Facebook', href: 'https://www.facebook.com/sithum.gimhana.645415?mibextid=ZbWKwL' },
              { icon: <FaInstagram />, label: 'Instagram', href: 'https://www.instagram.com/sithum_gimhana22/' },
              { icon: <FaDiscord />, label: 'Discord', href: 'https://discord.gg/urdgVdBs5q' },
              { icon: <FaXTwitter />, label: 'Twitter / X', href: 'https://x.com/devsithum' },
              { icon: <FaThreads />, label: 'Threads', href: 'https://www.threads.com/@sithum_gimhana22' },
              { icon: <FaTiktok />, label: 'TikTok', href: 'https://www.tiktok.com/@devsithum' },
              { icon: <FaYoutube />, label: 'YouTube', href: 'https://www.youtube.com/@devsithum' },
              { icon: <FaSpotify />, label: 'Spotify', href: 'https://open.spotify.com/user/31t5i2yg7zwgxpkauprkmcgb5q3q' },
              { icon: <FaSteam />, label: 'Steam', href: 'https://steamcommunity.com/profiles/76561199857905356/' },
              { icon: <FaTelegram />, label: 'Telegram', href: 'https://web.telegram.org/' },
              { icon: <FaPinterest />, label: 'Pinterest', href: 'https://www.pinterest.com/devsithum' },
            ].map(({ icon, label, href }, index) => (
              <div key={index} className="relative group">
                <a
                  href={href}
                  target='_blank' rel="noreferrer"
                  className="hover:text-blue-500 transition-transform duration-300 transform hover:scale-125
                  [text-shadow:0_0_8px_rgba(59,130,246,0.8),0_0_16px_rgba(59,130,246,0.6)]"
                >
                  {icon}
                </a>
                <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-2 py-1 rounded bg-slate-900 text-white text-xs opacity-0 group-hover:opacity-100 transition-all duration-300 pointer-events-none whitespace-nowrap z-50 shadow-md shadow-blue-500/40">
                  {label}
                </div>
              </div>
            ))}
          </div>
        </div>
        </div>

      {/* Bottom */}
      <div className="mt-10 text-center text-sm pt-4">
        <p>
          Developed by <span className="text-red-500">Dev Sithum Gimhana</span><br />
          &copy; 2020-2025 Dev Sithum. All Rights Reserved.
        </p>
      </div>
    </footer>
    </div>
      ) : (
    <Preloader />
  );
};

export default Home;